import React from 'react';

import { classnames } from '@lumapps/classnames';
import { HomeLink } from '@lumapps/contents/components/HomeLink';
import { useDataAttributes } from '@lumapps/data-attributes';
import { useInstanceLogo } from '@lumapps/instance/hooks/useInstanceLogo';
import { getBaseUrl } from '@lumapps/router';

import './index.scss';

export interface InstanceLogoProps {
    /** The link title */
    title?: string;
    /** custom class name */
    className?: string;
    /** whether this component is rendered in a loading context */
    isLoading?: boolean;
}

const CLASSNAME = 'instance-logo';
const SCOPE = 'instance';

/**
 * Instance logo with link to the instance home page
 */
export const InstanceLogo = React.forwardRef<HTMLAnchorElement, InstanceLogoProps>(
    ({ className, title, isLoading }, ref) => {
        const { get } = useDataAttributes(SCOPE);
        const baseProps = {
            ref,
            className: classnames(CLASSNAME, className),
            ...get({ element: 'logo' }),
        };
        const instanceLogo = useInstanceLogo();

        if (isLoading) {
            // While loading the app we cannot use a router link
            return (
                <a href={getBaseUrl(window.location.pathname)} {...baseProps}>
                    <img src={instanceLogo} alt={title} />
                </a>
            );
        }

        return (
            <HomeLink {...baseProps}>
                <img src={instanceLogo} alt={title} />
            </HomeLink>
        );
    },
);
InstanceLogo.displayName = 'InstanceLogo';
